module.exports = {
  init: async function(parent,settings={}){
    this._parent=parent;
    this._settings=settings;
    this._cache=false;
    this._connection_issue=false;
    this._key_prefix='user_data-';
  },
  has_connectionIssue: function()
  {
    return this._connection_issue;
  },
  refresh:async function(key)
  {
    this._cache=false;
    await this.get(key);
  },
  get:async function(key,force=false)
  {
    if(!key && key.length <= 0)
    {
      this._parent._log('debug','data.get','key is empty',key);
      return false;
    }

    if(force)
    {
      delete this._cache[key];
    }
    this._parent._log('debug','data.get','Getting '+key, force);
    if(this._cache && typeof this._cache == 'object' && (key in this._cache))
    {
      this._parent._log('debug','data.get','Has Cache',this._cache[key]);
      return this._cache[key];
    }
    else
    {
      if(!(typeof this._cache == 'object'))
      {
        this._cache={};
      }
      this._parent._log('debug','data.get','No cache');
      this._cache[key] = {'type': 'profile', 'name': this._key_prefix+key, 'data':{}, 'status': 'published'};

      let current_data=true;

      try
      {
        current_data = await this._parent.get('data','?type=profile&name='+this._cache[key].name+'&status=published&_[limit]=1',false,true);
        this._connection_issue=false;
      }
      catch(ex)
      {
        this._connection_issue=true;
        this._parent._log('error','data.get','data',ex);
      }

      if(Array.isArray(current_data) && current_data.length == 1)
      {
        this._parent._log('debug','data.get','Processing return',current_data);
        if('data' in current_data[0])
        {
          this._cache[key] = JSON.parse(JSON.stringify(current_data[0].data));
          if(typeof this._cache[key]!== 'object')
          {
            this._cache[key]=current_data[0].data;
          }
          this._parent._log('debug','data.get','From db',this._cache[key]);
          return this._cache[key];
        }
        else
        {
          this._parent._log('debug','data.get','mmm data missing for '+key,current_data[0]);
        }
      }
      else
      {
        this._parent._log('warn','data.get','Ok, no return for '+key+'... probably ok',current_data);
      }
    }
    return null;
  },
  has:async function(key,callback=false,force=false)
  {
    let current_data = await this.get(key,force);
    let result = false;
    if(current_data !== null)
    {
      result = true;
    }
    if(typeof callback == 'function')
    {
      callback(result);
    }
    return result;
  },
  remove:async function(post_id)
  {
    throw 'Not implemented';
  },
  set:async function(key,data)
  {
    try
    {
      if(key && key.length > 0)
      {
        let record = {'type': 'profile', 'name': this._key_prefix+key, 'data':{}, 'status': 'published'};
        this._parent._log('debug','data.set['+key+']','Setting to',data);
        record.data=data;

        let result =  await this._parent.post('data',record);
        window.dispatchEvent(new CustomEvent('dsb-pwa-page_event', {detail:{
          'event_type':'user_data',
          'data': {
            'action':'set',
            'id':key
          }
        }}));

        if(key in this._cache)
        {
          delete this._cache[key];
          this._parent._log('debug','data.set['+key+']','Clearing _cache for '+key,this._cache);
        }
        await this.get(key);
        return result;
      }
      else
      {
        throw "key is empty";
      }

    }
    catch(ex)
    {
        this._parent._log('error','data.set['+key+']',ex);
        return false;
    }

  }
}
